
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";

export default Vue.extend({
	data(){
		return {
			file: null as null | File
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.file) return;
			let text = await this.file.text();
			let layout = JSON.parse(text);
			this.$emit("input", layout);
			this.close();
		}
	},
	components: {
		AppFileUpload
	}
});
